import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useEntityGraphContext } from '../../Wrapper/EntityGraphProvider'
import { DisplayOptions } from './DisplayOptions'
import { NodeProps } from './NodeProps'
import { NodeColors } from './NodeColors'

export const NodeSettings = ({ nodeId }) => {
  const { state: { data }, dispatch } = useEntityGraphContext()

  const node = useMemo(() => data?.nodes?.find(node => node.id === nodeId), [data, nodeId])

  const updateNode = (path, value) => {
    dispatch({
      type: 'UPDATE_NODE',
      payload: { nodeId, path, value }
    })
  }
  return (
    <div className='flex flex-col gap-2 mt-4'>
      <NodeProps node={node} onUpdateNode={updateNode} />
      <hr className='w-full' />
      <NodeColors node={node} onUpdateNode={updateNode} />
      <hr className='w-full' />
      <DisplayOptions onUpdateNode={updateNode} node={node} />
    </div>
  )
}

NodeSettings.propTypes = {
  nodeId: PropTypes.string.isRequired
}
